import React, { Fragment } from 'react';

const Option = ({ options }) => {
    return (
        <Fragment>
            {options.map((option, index) => (
                <option key={index} value={option.value ? option.value : option}>
                    {option.title ? option.title : option}
                </option>
            ))}
        </Fragment>
    );
};

export default function Selector({ selected, options, onChangeSelect }) {
    return (
        <select className="select_lan" value={selected} id={selected} onChange={(e) => onChangeSelect(e)}>
            <Option options={options} />
        </select>
    );
}
